import React from "react";
import MasterPageTab from "./page-essential/MasterPageTab";
import { BsGoogle } from "react-icons/bs";
import TabAddMeta from "./page-components/MetaTags/TabAddMeta";
import TabViewMeta from "./page-components/MetaTags/TabViewMeta";

const MetaTags = () => {
  return (
    <div>
      <MasterPageTab
        addBtn="Add Meta Data"
        viewBtn="View Meta Data"
        addTab={<TabAddMeta />}
        viewTab={<TabViewMeta />}
        pageHeading="Page Meta Data for SEO"
        pageDescription="Make your website seo friendly by adding title, description and keyoword on each page"
        icon={null}
      />
    </div>
  );
};

export default MetaTags;
